import React from 'react';
import styles from './Badge.module.css';

/**
 * Badge   small rounded pill with optional dot.
 * variant: 'cyan' | 'purple' | 'dark' | 'soft'
 */
const Badge = ({ children, variant = 'cyan', withDot = true, className = '' }) => {
  return (
    <span className={`${styles.badge} ${styles[variant]} ${className}`}>
      {withDot && <span className={styles.dot} />}
      <span className={styles.text}>{children}</span>
    </span>
  );
};

export default Badge;
